import { Direction, Directionality } from "@angular/cdk/bidi";
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Device } from "@ionic-native/device/ngx";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService, DeviceType } from "ngx-device-detector";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { AlertsService } from "./AlertsService";
import { ErrorValidatorService } from "./common/directives/error-handler/error-validator.service";
import {
  EAccountServiceCode,
  EDepositServiceCode,
} from "./common/models/service-code.model";
import { MobileService } from "./mobile.services";
import { IDeviceInfo } from "./models/app-common.model";
import { SpinnerService } from "./services/spinner/spinner.service";
import { UserService } from "./user.service";
import { DialogService } from "./fpx-core/services/dialog/dialog.service";
import MENUJSON from "./_files/menus.json";
import { FcmNotificationService } from "./fcm-notification.service";
import { API_DATE_FORMAT } from "./fpx-core/constant";
import moment from "moment";

declare var jscd: any;
declare var window: any;
declare let $: any;
declare const JSEncrypt: any;

@Injectable({
  providedIn: "root",
})
export class CommonService {

  backNav = new EventEmitter();
  public searchRequired: boolean = false;
  public serviceDescription: string = "";
  public isbackBtn:boolean= false;
  language: string = "En";
  desktopVersion: boolean;
  mobileVersion: boolean;
  tabletVersion: boolean;
  encodedDeviceDetails: string;
  deviceInfo: IDeviceInfo;
  switchLanguage$ : BehaviorSubject<string> = new BehaviorSubject<string>(this.language);

  customerCode: string = "";
  contractnumber="";
  rtlDirection$ = new Subject<boolean>();
  isRtl: boolean = false;

  baseCurrency: string = "PGK";
  baseCurrencySymbol: string = "PGK";
  showLangSwitcher: boolean;
  SALT =
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA32rpoAO6Obi/4kydkyqHTd5Co5vfXatm/hTBlUVy66hlHpINiyHWcQUlRpPka0YLB4oEReccCzfJT37+CJ6riJ48wefEslNf2wNFuuBMbykSk4dp6XF+RvbL2Lo6aGhr+ZvSKRDx63OgCp2tarFbbo6WEXQx1HTGTl0A3i8mX02VlHpZMK9m3xSg5XYnEpRUMuGUHJQuhafrRAybPkoAQBrH88Y27os2F+M1cp8OYWUeEo+SRlkVSaWPgauZ6IXwmX5lL6J2dQHQZowHqy6IiYk0bCXsHHCcYBLHeW25wlCqKvstUN/Fud1B/IYBp845rh8bGOZEz4oXjpCm1S09oQIDAQAB";

  isMpinRegistered: boolean = false;
  isDeviceAuthRegistered: boolean = false;
  searchMenuList = [];

  manageSecurityItem: any;
  PurchaseOrderItem: any;
  SellOrderItem: any;

  mutualAvailable: boolean = false;
  serviceUnAvailable: boolean;
  newMails:number;

  mobilePayID:string;
  emailPayID:string;
  whatsAppyID:string;
  primaryAccVal: string;
  mobileNumber:string;
  whatsappNumber:string;
  email:string;
  inventoryNumber: any;
  primAccChange: boolean = false;
   
  flow: any;
  isNetworkDown: boolean = false;
  serverDate: string;
  byPassDebitCardScreen: boolean = true;
  setFlow(flow) {
    this.flow = flow;
  }
  getFlow() {
    return this.flow;
  }

    cardRefNumber: any;
  setcardRefNumber(cardRefNumber) {
    this.cardRefNumber = cardRefNumber;
  }
  getcardRefNumber() {
    return this.cardRefNumber;
  }
  constructor(
    public translate: TranslateService,
    private _router: Router,
    private _deviceDetector: DeviceDetectorService,
    public _alertsService: AlertsService,
    private dir: Directionality,
    private _spinnerService: SpinnerService,
    private _userService: UserService,
    private _device: Device,
    private _mobileService: MobileService,
    private _titleService: Title,
    private _httpClient: HttpClient,
    private _errorMessage: ErrorValidatorService,
    private _dialogService: DialogService,
    private _fcmService:FcmNotificationService
  ) {
    this.language = localStorage.getItem("lang") || "En";
    let direction: Direction = this.language == "ar" ? "rtl" : "ltr";
    this.dir.change.emit(direction);

    this.manageSecurityItem = {
      id: "manage-security-settings",
      icon: "manage-security",
      name: "CONTEXTULAMENU.manageSecuritySettings",
      title: "CONTEXTULAMENU.manageSecuritySettingsTitle",
      path: ["shell", "settings", "manage-security-settings"],
      desktopPath: ["home", "settings", "manage-security-settings"],
    };

    this.PurchaseOrderItem = {
      id: "M001",
      icon: "purchase-order",
      name: "CONTEXTULAMENU.purchaseOrder",
      title: "CONTEXTULAMENU.purchaseOrderTitle",
      path: ["shell", "transactions", "mutual-funds", "purchase-order"],
      desktopPath: ["home", "transactions", "mutual-funds", "purchase-order"],
    };
    this.SellOrderItem = {
      id: "M002",
      icon: "sell-order",
      name: "CONTEXTULAMENU.sellOrder",
      title: "CONTEXTULAMENU.sellOrderTitle",
      path: ["shell", "transactions", "mutual-funds", "sell-order"],
      desktopPath: ["home", "transactions", "mutual-funds", "sell-order"],
    };
    this.searchMenuList = MENUJSON.menus;
  }

  public initializeUIClass() {
    this.desktopVersion =
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Desktop ||
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Tablet;
    this.tabletVersion =
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Tablet;
    this.mobileVersion = !this.desktopVersion;
  }

  public isDesktop(): boolean {
    return this.desktopVersion;
  }

  public isTablet(): boolean {
    return this.tabletVersion;
  }

  public isMobile(): boolean {
    return this.mobileVersion;
  }

  public isHybrid(): boolean {
    return window["cordova"] ? true : false;
  }

  compareWithExistForm(currentFormData, previousFormData) {
    let deepCompare = (arg1, arg2) => {
      if (
        Object.prototype.toString.call(arg1) ===
        Object.prototype.toString.call(arg2)
      ) {
        if (
          Object.prototype.toString.call(arg1) === "[object Object]" ||
          Object.prototype.toString.call(arg1) === "[object Array]"
        ) {
          if (Object.keys(arg1).length !== Object.keys(arg2).length) {
            return false;
          }
          return Object.keys(arg1).every(function (key) {
            return deepCompare(arg1[key], arg2[key]);
          });
        }
        return arg1 === arg2;
      }
      return false;
    };
    return deepCompare(previousFormData, currentFormData);
  }

  public showManageSecurity() {
    console.log("Before splitting : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.isDesktop()) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.manageSecurityItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else {
      let isavailable;
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.manageSecurityItem,
          this.searchMenuList[i]
        );
        compareRes ? (isavailable = true) : (isavailable = false);
      }

      if (!isavailable) {
        this.searchMenuList.push(this.manageSecurityItem);
      }
    }

    console.log("After splitting : ", this.searchMenuList);
  }

  public showPurchaseOrder() {
    console.log("Before splitting In Purchse Order : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.mutualAvailable == false) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.PurchaseOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else if (this.mutualAvailable == true) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.PurchaseOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (!Spliceindex) this.searchMenuList.push(this.PurchaseOrderItem);
    }

    console.log("After splitting In Purchase Order : ", this.searchMenuList);
  }

  public showSellOrder() {
    console.log("Before splitting In Sell Order : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.mutualAvailable == false) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.SellOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else if (this.mutualAvailable == true) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.SellOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (!Spliceindex) this.searchMenuList.push(this.SellOrderItem);
    }

    console.log("After splitting In Sell Order: ", this.searchMenuList);
  }

  switchLanguage(language: string = "En") {
    this.translate.use(language);

    let rtl: boolean = false;
    document.getElementsByTagName("html")[0].setAttribute("lang", language);
    this.getErrorMessage(language);
    if (language === "ar") {
      environment.languageId = "ar_US";
      this._titleService.setTitle("Credit Bank");
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
      rtl = true;
    } else {
      environment.languageId = "en_US";
      this._titleService.setTitle("Credit Bank");
      document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
      rtl = false;
    }
    localStorage.setItem("lang", language);
    this.language = language;
    this.isRtl = rtl;
    this.rtlDirection$.next(rtl);

    let direction: Direction = rtl ? "rtl" : "ltr";
    this.dir.change.emit(direction);
    this.switchLanguage$.next(language);
  }

  getErrorMessage(lang) {
    this._httpClient
      .get("./assets/i18n/val_" + lang.toLowerCase() + ".json")
      .subscribe({
        next: (res) => {
          this._errorMessage.setErrorData(res);
        },
      });
  }

  setToken(token) {
    this._userService.setToken(token);
  }

  onLoginSuccess(data) {
    this.customerCode = data.loginauth.userId;
    sessionStorage.setItem("customerCode", this.customerCode);
    if (data && data.loginauth.authToken) {
      this.setToken(data.loginauth.authToken);
    }
  }

  loginOTPSuccess(response) {}

  getDeviceDetails(): IDeviceInfo {
    let deviceInfo: IDeviceInfo = this._deviceDetector.getDeviceInfo();
    if (this.isHybrid()) {
      deviceInfo = {
        ...deviceInfo,
        os_version: this._device.version,
        model: this._device.model,
        manufacturer: this._device.manufacturer,
        deviceId: this._mobileService.deviceID,
        app_version: this._mobileService.appVersionInfo.versionNumber,
        build_number: this._mobileService.appVersionInfo.buildNumber,
        packageName: this._mobileService.appVersionInfo.packageName,
        deviceName: window["device"].name,
        fcmToken:this._fcmService.fcmToken
      };
    } else {
      deviceInfo = {
        ...deviceInfo,
        deviceId: window["browserFingerprint"],
      };
    }
    deviceInfo.isHybrid = this.isHybrid();
    deviceInfo.device =
      deviceInfo.device == "Unknown"
        ? deviceInfo.os_version
        : deviceInfo.device;
    console.log("deviceInfo:", deviceInfo);
    // deviceInfo.deviceType = "desktop";
    // Get windows 11 start
    if (this.isDesktop() && 
      navigator["userAgentData"] &&
      navigator["userAgentData"].getHighEntropyValues(["platformVersion"])
    ) {
      navigator["userAgentData"]
        .getHighEntropyValues(["platformVersion"])
        .then((ua) => {
          if (navigator["userAgentData"].platform === "Windows") {
            const majorPlatformVersion = parseInt(
              ua.platformVersion.split(".")[0]
            );

            if (majorPlatformVersion >= 13 && !this.isMobile()) {
              deviceInfo.os_version = "windows-11";
              this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
              return deviceInfo;
            } else {
              this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
              return deviceInfo;
            }
          } else {
            this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
            return deviceInfo;
          }
        });
    } else {
      this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
      return deviceInfo;
    }
    // Get windows 11 end
  }

  showSpinner() {
    this._spinnerService.show();
  }
  hideSpinner() {
    this._spinnerService.hide();
  }
  formatAmount(number) {
    return new Intl.NumberFormat(environment.currencyFormat, {
      minimumFractionDigits: 2,
    }).format(number);
  }

  resetPageScroll(scrollTo: number) {
    if (this.isMobile()) {
      // window._scrollTop(scrollTo);
      $(document).scrollTop(0);
    } else {
      setTimeout(() => {
        $("app-root").scrollTop(scrollTo);
      }, 50);
    }
  }

  doEncrypt(message: string): string {
    try {
      let encrypt = new JSEncrypt();
      encrypt.setKey(this.SALT);
      let enc = encrypt.encrypt(message);
      return enc;
    } catch (error) {
      return message;
    }
  }
  doDecrypt(message: string,key:string): string {
    try {
      let decrypt = new JSEncrypt();
      decrypt.setKey(key);
      let enc = decrypt.decrypt(message);
      return enc;
    } catch (error) {
      return message;
    }
  }
  openDocument(fileName) {
    window.open("assets/documents/" + fileName, "_system");
  }

  base64ToBlob(base64: string) {
    let sliceSize: number = 1024;
    let base64Data = base64.split(",");
    let b64Data = base64Data[1];
    let contentType = base64Data[0].match(/:(.*?);/)[1];
    const byteCharacters = atob(b64Data);

    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  base64ToFile(base64: string, filename: string) {
    var arr = base64.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = window.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  fileToBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  async filePathToBlob(filePath): Promise<Blob> {
    let fileBlob;
    await fetch(filePath)
      .then((res) => res.blob())
      .then((blob) => {
        console.log(blob);
        fileBlob = blob;
      });
    return fileBlob;
  }

  scaleDownImage(base64: string, width: number = 768): Promise<any> {
    let mime = base64.split(",")[0].match(/:(.*?);/)[1];
    let height;

    return new Promise((resolve, reject) => {
      const image = new Image();

      image.onload = () => {
        let canvas = document.createElement("canvas");
        let ratio = image.width / image.height;
        canvas.width = width;
        height = width / ratio;
        canvas.height = height;
        let context = canvas.getContext("2d");
        context.scale(width / image.width, height / image.height);
        context.drawImage(image, 0, 0);
        const newBase64Image = canvas.toDataURL(mime);

        resolve(newBase64Image);
      };
      image.onerror = (el, err) => {
        reject(err);
      };

      image.src = base64;
    });
  }


  getNameInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      initial=initial.toUpperCase();
      return initial ;
    }
    return
  }

  // percentageCalculator(totalValue,spendValue){


  //   let percentage = (100 * parseFloat(spendValue)) / parseFloat(totalValue);
  //   if(percentage?.toString()?.includes('.')){
  //     return parseFloat(percentage.toFixed(2));
  //   }
  //   return percentage;
  // }

  showVersionUpdateAlert(id:string, title:string, message: string, button: any[], component: string){
    let CBXDialogData = {
      title: title,
      message: message,
      button: button,
    }
    this._dialogService.open({
      component: component,
      data: CBXDialogData,
      closeFn: (res) => this.showVersionUpdateAlertClose(id, res)
    })
  }

  showVersionUpdateAlertClose(id:string, result:any){
    if(result == 1){
      if(id == "sslInValid"){
        let bodyEl = document.getElementsByTagName("body");
        bodyEl[0].setAttribute("style", "opacity:0.5; pointer-events:none;");
        let platform = this._mobileService.device.platform.toLowerCase();
        let storeURL = "";
        if (platform == 'android') {
          storeURL = environment.playstoreURL;
        }
        else if (platform == 'ios') {
          storeURL = environment.appstoreURL;
        }
        window.open(storeURL);
      }
      
    }
  }


  getFileMimeType(fileType) {
    if (fileType.match(/png/)) {
      return 'image/png';
    } else if (fileType.match(/pdf/)) {
      return 'application/pdf';
    }
    else if (fileType.match(/jpg|jpeg/)) {
      return 'image/jpeg';
    }
    else if (fileType.match(/doc/)) {
      return 'application/msword';
    }
    else if (fileType.match(/docx/)) {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }
    else if (fileType.match(/xls/)) {
      return 'application/vnd.ms-excel';
    }
    else if (fileType.match(/txt/)) {
      return 'text/plain';
    }
  }

  decodeFileName(response): string {
    var filename = "";
    var disposition = response.headers.get('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        return filename = matches[1].replace(/['"]/g, '');
      }
    }
  }

  getCurrentDateAsServerDate(systemDate):string{
    return moment().format(API_DATE_FORMAT)===systemDate?this.serverDate:systemDate
  }


}

